import { ComponentProps } from "react"

import { twMerge } from "tailwind-merge"

import { buttonClassName } from "./sharedClassNames"

export type ButtonProps = { kind?: "primary" | "secondary" | "ghost" } & ComponentProps<"button">

/**
 * Thin wrapper around the native button element forwarding its ref.
 */
export function Button(props: ButtonProps) {
  const { className, type = "button", kind = "primary", ...restProps } = props

  return <button type={type} className={twMerge(buttonClassName(kind), className)} {...restProps} />
}
